import template from './entitler.html';
import controller from './entitler.controller';

let entitlerComponent = {
  restrict: 'E',
  bindings: {},
  template,
  controller,
  controllerAs: 'vm'
};

export default entitlerComponent;



// WEBPACK FOOTER //
// ./app/components/entitler/entitler.component.js